// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"50779a15","380":"9c2add9b","702":"c40fdaf1"}[chunkId] + ".chunk.css";
};